import React from "react";

export default function Repeat({element: Element, count}: {
    element: React.FC,
    count: number
}) {
    return Array<void>(count).fill().map((_, index) => <Element key={index} />)
}